import React, { Component } from "react";
import { API_URL } from '../../Config';

import { handleErrors } from '../../Helpers'

export default class Soundtracks extends Component {

  componentWillMount() {
    this.props.setMenuIndex();
  }

  componentDidMount() {
    this.props.updateData()
  }

  changePlaylist(id) {
    const currentZone = window.persistence.local.get("currentZone").token;
    fetch(`${API_URL}/zone?token=${currentZone}`, {
      method: "PATCH",
      body: JSON.stringify({
        action: "setPlayFrom",
        id: id
      })
    })
      .then(handleErrors)
      .then(response => response.json())
      .then(response => {
        this.props.history.push("/player");
      })
      .catch(error => console.error("Error", error))
  }

  render() {
    return (
      <div>
        {this.props.data.length ? (
          <ul>
            {this.props.data.map((item, i) => (
              <li key={i} style={{ marginBottom: '.5rem', cursor: 'pointer' }}>
                <div style={{ position: 'relative', height: '22rem', display: 'flex', overflow: 'hidden', borderRadius: '4px' }} onClick={() => this.changePlaylist(item.id)}>
                  <h1 style={{ color: '#FFF', position: 'absolute', bottom: '.75rem', left: '1rem' }}>{item.name}</h1>
                  {this.props.currentPlayFrom && this.props.currentPlayFrom.playFrom.name === item.name && (
                    <span style={{ color: '#FFF', position: 'absolute', top: '.75rem', left: '1rem' }}>Now Playing</span>
                  )}
                  {item.presentation.image && item.presentation.image.large && 
                    <img style={{ width: '100%', objectFit: 'cover', objectPosition: 'center 70%', }} src={item.presentation.image.large.url} alt={item.name} /> ||
                    <div style={{width: '100%', height: '352px', backgroundColor: '#0019F8', }}></div>
                  }
                </div>
              </li>
            ))}
          </ul>
        ) : (<div style={{ textAlign: 'center', margin: '1rem 0' }}>You haven't added any soundtracks yet</div>)
      }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Views/ChangeMusic/Soundtracks.js